"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/**
* Data service.
* @module api/DataApi
* @version 0.1.0
*/
var DataApi = /*#__PURE__*/function () {
  /**
  * Constructs a new DataApi. 
  * @alias module:api/DataApi
  * @class
  * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
  * default to {@link module:ApiClient#instance} if unspecified.
  */
  function DataApi(apiClient) {
    _classCallCheck(this, DataApi);
    this.apiClient = apiClient || _ApiClient["default"].instance;
  }

  /**
   * @param {String} resourceType Type of the resource.
   * @param {Number} resourceId ID of the resource.
   * @param {String} type The type of data to return.
   * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
   * @param {Object} opts Optional parameters
   * @param {String} opts.period Pre-defined period of time to retrieve.
   * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
   * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
   */
  _createClass(DataApi, [{
    key: "getChildEnergyBreakdownWithHttpInfo",
    value: function getChildEnergyBreakdownWithHttpInfo(resourceType, resourceId, type, start, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getChildEnergyBreakdown");
      }
      // verify the required parameter 'resourceId' is set
      if (resourceId === undefined || resourceId === null) {
        throw new Error("Missing the required parameter 'resourceId' when calling getChildEnergyBreakdown");
      }
      // verify the required parameter 'type' is set
      if (type === undefined || type === null) {
        throw new Error("Missing the required parameter 'type' when calling getChildEnergyBreakdown");
      }
      // verify the required parameter 'start' is set
      if (start === undefined || start === null) {
        throw new Error("Missing the required parameter 'start' when calling getChildEnergyBreakdown");
      }
      var pathParams = {
        'resourceType': resourceType,
        'resourceId': resourceId
      };
      var queryParams = {
        'type': type,
        'period': opts['period'],
        'start': start,
        'end': opts['end']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiKey', 'ApiSoftAuthorizer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/data/{resourceType}/{resourceId}/energy/child-breakdown', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @param {String} type The type of data to return.
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.period Pre-defined period of time to retrieve.
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getChildEnergyBreakdown",
    value: function getChildEnergyBreakdown(resourceType, resourceId, type, start, opts) {
      return this.getChildEnergyBreakdownWithHttpInfo(resourceType, resourceId, type, start, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getChildEnergyStatsWithHttpInfo",
    value: function getChildEnergyStatsWithHttpInfo(resourceType, resourceId) {
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getChildEnergyStats");
      }
      // verify the required parameter 'resourceId' is set
      if (resourceId === undefined || resourceId === null) {
        throw new Error("Missing the required parameter 'resourceId' when calling getChildEnergyStats");
      }
      var pathParams = {
        'resourceType': resourceType,
        'resourceId': resourceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiKey', 'ApiSoftAuthorizer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/data/{resourceType}/{resourceId}/energy/child-stats', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getChildEnergyStats",
    value: function getChildEnergyStats(resourceType, resourceId) {
      return this.getChildEnergyStatsWithHttpInfo(resourceType, resourceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getChildSolarStatsWithHttpInfo",
    value: function getChildSolarStatsWithHttpInfo(resourceType, resourceId) {
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getChildSolarStats");
      }
      // verify the required parameter 'resourceId' is set
      if (resourceId === undefined || resourceId === null) {
        throw new Error("Missing the required parameter 'resourceId' when calling getChildSolarStats");
      }
      var pathParams = {
        'resourceType': resourceType,
        'resourceId': resourceId
      };
      var queryParams = {};
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/data/{resourceType}/{resourceId}/solar/child-stats', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getChildSolarStats",
    value: function getChildSolarStats(resourceType, resourceId) {
      return this.getChildSolarStatsWithHttpInfo(resourceType, resourceId).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 5 minute, 30 minute, day, month or year.
     * @param {Boolean} opts.weather Attach weather to the data.
     * @param {Boolean} opts.includeDisabled Include disabled virtual meter data sources.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getEnergyFeedWithHttpInfo",
    value: function getEnergyFeedWithHttpInfo(resourceType, resourceId, start, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getEnergyFeed");
      }
      // verify the required parameter 'resourceId' is set
      if (resourceId === undefined || resourceId === null) {
        throw new Error("Missing the required parameter 'resourceId' when calling getEnergyFeed");
      }
      // verify the required parameter 'start' is set
      if (start === undefined || start === null) {
        throw new Error("Missing the required parameter 'start' when calling getEnergyFeed");
      }
      var pathParams = {
        'resourceType': resourceType,
        'resourceId': resourceId
      };
      var queryParams = {
        'start': start,
        'end': opts['end'],
        'aggregation': opts['aggregation'],
        'weather': opts['weather'],
        'includeDisabled': opts['includeDisabled']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiKey', 'ApiSoftAuthorizer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/data/{resourceType}/{resourceId}/energy/feed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 5 minute, 30 minute, day, month or year.
     * @param {Boolean} opts.weather Attach weather to the data.
     * @param {Boolean} opts.includeDisabled Include disabled virtual meter data sources.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getEnergyFeed",
    value: function getEnergyFeed(resourceType, resourceId, start, opts) {
      return this.getEnergyFeedWithHttpInfo(resourceType, resourceId, start, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @param {Object} opts Optional parameters
     * @param {String} opts.start The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
     * @param {String} opts.end The date in ISO format - YYYY-MM-DD - without a timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getEnergyStatsWithHttpInfo",
    value: function getEnergyStatsWithHttpInfo(resourceType, resourceId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getEnergyStats");
      }
      // verify the required parameter 'resourceId' is set
      if (resourceId === undefined || resourceId === null) {
        throw new Error("Missing the required parameter 'resourceId' when calling getEnergyStats");
      }
      var pathParams = {
        'resourceType': resourceType,
        'resourceId': resourceId
      };
      var queryParams = {
        'start': opts['start'],
        'end': opts['end']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = ['ApiKey', 'ApiSoftAuthorizer'];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/data/{resourceType}/{resourceId}/energy/stats', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @param {Object} opts Optional parameters
     * @param {String} opts.start The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
     * @param {String} opts.end The date in ISO format - YYYY-MM-DD - without a timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getEnergyStats",
    value: function getEnergyStats(resourceType, resourceId, opts) {
      return this.getEnergyStatsWithHttpInfo(resourceType, resourceId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @param {Object} opts Optional parameters
     * @param {String} opts.order Ordering of the ranking.
     * @param {Boolean} opts.averageByPopulation Should the consumption be averaged by the site's population?
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getSitesEnergyRankingWithHttpInfo",
    value: function getSitesEnergyRankingWithHttpInfo(resourceType, resourceId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getSitesEnergyRanking");
      }
      // verify the required parameter 'resourceId' is set
      if (resourceId === undefined || resourceId === null) {
        throw new Error("Missing the required parameter 'resourceId' when calling getSitesEnergyRanking");
      }
      var pathParams = {
        'resourceType': resourceType,
        'resourceId': resourceId
      };
      var queryParams = {
        'order': opts['order'],
        'averageByPopulation': opts['averageByPopulation']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/data/{resourceType}/{resourceId}/sites/energy/ranking', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Type of the resource.
     * @param {Number} resourceId ID of the resource.
     * @param {Object} opts Optional parameters
     * @param {String} opts.order Ordering of the ranking.
     * @param {Boolean} opts.averageByPopulation Should the consumption be averaged by the site's population?
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getSitesEnergyRanking",
    value: function getSitesEnergyRanking(resourceType, resourceId, opts) {
      return this.getSitesEnergyRankingWithHttpInfo(resourceType, resourceId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} resourceType Type of the resource; schemas, organisations, sites or meters.
     * @param {Number} resourceId ID of the resource.
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 15 minute, day, month or year.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWaterFeedWithHttpInfo",
    value: function getWaterFeedWithHttpInfo(resourceType, resourceId, start, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getWaterFeed");
      }
      // verify the required parameter 'resourceId' is set
      if (resourceId === undefined || resourceId === null) {
        throw new Error("Missing the required parameter 'resourceId' when calling getWaterFeed");
      }
      // verify the required parameter 'start' is set
      if (start === undefined || start === null) {
        throw new Error("Missing the required parameter 'start' when calling getWaterFeed");
      }
      var pathParams = {
        'resourceType': resourceType,
        'resourceId': resourceId
      };
      var queryParams = {
        'start': start,
        'end': opts['end'],
        'aggregation': opts['aggregation']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/data/{resourceType}/{resourceId}/water/feed', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Type of the resource; schemas, organisations, sites or meters.
     * @param {Number} resourceId ID of the resource.
     * @param {String} start The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - without a timezone.
     * @param {Object} opts Optional parameters
     * @param {String} opts.end The date and time in ISO format - YYYY-MM-DD or YYYY-MM-DD HH:mm:ss or YYYY-MM-DDTHH:mm:ss - format without a timezone.
     * @param {String} opts.aggregation Suggested aggregation of the data. Is not guaranteed if date range is too large for the aggregation type. 15 minute, day, month or year.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getWaterFeed",
    value: function getWaterFeed(resourceType, resourceId, start, opts) {
      return this.getWaterFeedWithHttpInfo(resourceType, resourceId, start, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }

    /**
     * @param {String} resourceType Type of the resource; schemas, organisations, sites or meters.
     * @param {Number} resourceId ID of the resource.
     * @param {Object} opts Optional parameters
     * @param {String} opts.start The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
     * @param {String} opts.end The date in ISO format - YYYY-MM-DD - without a timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with an object containing data of type {@link Object} and HTTP response
     */
  }, {
    key: "getWaterStatsWithHttpInfo",
    value: function getWaterStatsWithHttpInfo(resourceType, resourceId, opts) {
      opts = opts || {};
      var postBody = null;
      // verify the required parameter 'resourceType' is set
      if (resourceType === undefined || resourceType === null) {
        throw new Error("Missing the required parameter 'resourceType' when calling getWaterStats");
      }
      // verify the required parameter 'resourceId' is set
      if (resourceId === undefined || resourceId === null) {
        throw new Error("Missing the required parameter 'resourceId' when calling getWaterStats");
      }
      var pathParams = {
        'resourceType': resourceType,
        'resourceId': resourceId
      };
      var queryParams = {
        'start': opts['start'],
        'end': opts['end']
      };
      var headerParams = {};
      var formParams = {};
      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = Object;
      return this.apiClient.callApi('/data/{resourceType}/{resourceId}/water/stats', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, null);
    }

    /**
     * @param {String} resourceType Type of the resource; schemas, organisations, sites or meters.
     * @param {Number} resourceId ID of the resource.
     * @param {Object} opts Optional parameters
     * @param {String} opts.start The date in ISO format - YYYY-MM-DD - without a timezone. If no date is provided, the data will default to lifetime.
     * @param {String} opts.end The date in ISO format - YYYY-MM-DD - without a timezone.
     * @return {Promise} a {@link https://www.promisejs.org/|Promise}, with data of type {@link Object}
     */
  }, {
    key: "getWaterStats",
    value: function getWaterStats(resourceType, resourceId, opts) {
      return this.getWaterStatsWithHttpInfo(resourceType, resourceId, opts).then(function (response_and_data) {
        return response_and_data.data;
      });
    }
  }]);
  return DataApi;
}();
exports["default"] = DataApi;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@solarschools/api-sdk/dist/api/DataApi.js
// module id = wbBc
// module chunks = 22